import { createReducer, on } from '@ngrx/store';
import * as paginationConstants from '../../../shared/constants/pagination.constants';
import * as tariffActions from './tariff.actions';
import { SavingStatus } from '../../../shared/models/list.page.model';
import { TariffsState } from './tariff.models';

export const tariffInitialState: TariffsState = {
  tariffs: [],
  tariffsPage: null,
  tariffsPagination: {
    pageIndex: 0,
    pageSize: paginationConstants.DefaultPageSize,
  },
  tariffsSaveInProgress: SavingStatus.NotStarted,
  error: null,
  loading: false,
};

export const tariffReducer = createReducer(
  tariffInitialState,
  on(tariffActions.loadTariffList, (state) => ({
    ...state,
    loading: true,
  })),
  on(tariffActions.loadTariffListFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'Error',
  })),
  on(tariffActions.loadTariffListSuccess, (state, { tariffsResponse }) => ({
    ...state,
    loading: false,
    error: null,
    tariffs: tariffsResponse.result ?? [],
    tariffsPage: {
      ...state.tariffsPage,
      totalCount: tariffsResponse.total ?? 0,
      pageIndex: tariffsResponse.pageIndex ?? 0,
      pageSize: tariffsResponse.pageSize ?? 0,
    },
  })),
  on(
    tariffActions.changeTariffPagination,
    (state, { pageIndex, pageSize }) => ({
      ...state,
      tariffsPagination: {
        pageIndex,
        pageSize,
      },
    })
  ),
  on(tariffActions.updateTariff, (state) => ({
    ...state,
    loading: true,
    tariffsSaveInProgress: SavingStatus.InProgress,
  })),
  on(tariffActions.updateTariffSuccess, (state) => ({
    ...state,
    loading: false,
    tariffsSaveInProgress: SavingStatus.Successful,
  })),
  on(tariffActions.updateTariffFailure, (state, { error }) => ({
    ...state,
    loading: false,
    tariffsSaveInProgress: SavingStatus.Failure,
    error: error.errorMessage ?? 'ERROR',
  })),
  on(tariffActions.insertNewTariff, (state) => ({
    ...state,
    loading: true,
    tariffsSaveInProgress: SavingStatus.InProgress,
  })),
  on(tariffActions.insertNewTariffSuccess, (state) => ({
    ...state,
    loading: false,
    tariffsSaveInProgress: SavingStatus.Successful,
  })),
  on(tariffActions.insertNewTariffFailure, (state, { error }) => ({
    ...state,
    loading: false,
    tariffsSaveInProgress: SavingStatus.Failure,
    error: error.errorMessage ?? 'ERROR',
  })),
  on(tariffActions.tariffMarkedAsStandard, (state, { tariffId }) => ({
    ...state,
    loading: false,
    tariffsSaveInProgress: SavingStatus.Successful,
    tariffs: state.tariffs.map((t) => ({
      ...t,
      isStandard: t.id === tariffId,
    })),
  })),
  on(tariffActions.deleteNewTariffSuccess, (state) => ({
    ...state,
    tariffsSaveInProgress: SavingStatus.Successful,
  })),
  on(tariffActions.insertNewTariffFailure, (state, { error }) => ({
    ...state,
    loading: false,
    tariffsSaveInProgress: SavingStatus.Failure,
    error: error.errorMessage ?? 'ERROR',
  }))
);
